// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"f92a6f83","768":"8017f1ec"}[chunkId] + ".chunk.js";
};